/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ViewedPopupRequestModelAgreementTermPopup } from './ViewedPopupRequestModelAgreementTermPopup';
import {
    ViewedPopupRequestModelAgreementTermPopupFromJSON,
    ViewedPopupRequestModelAgreementTermPopupFromJSONTyped,
    ViewedPopupRequestModelAgreementTermPopupToJSON,
} from './ViewedPopupRequestModelAgreementTermPopup';
import type { ViewedPopupRequestModelCampaignPopup } from './ViewedPopupRequestModelCampaignPopup';
import {
    ViewedPopupRequestModelCampaignPopupFromJSON,
    ViewedPopupRequestModelCampaignPopupFromJSONTyped,
    ViewedPopupRequestModelCampaignPopupToJSON,
} from './ViewedPopupRequestModelCampaignPopup';
import type { ViewedPopupRequestModelMissionPopup } from './ViewedPopupRequestModelMissionPopup';
import {
    ViewedPopupRequestModelMissionPopupFromJSON,
    ViewedPopupRequestModelMissionPopupFromJSONTyped,
    ViewedPopupRequestModelMissionPopupToJSON,
} from './ViewedPopupRequestModelMissionPopup';
import type { ViewedPopupRequestModelNewArticlePopup } from './ViewedPopupRequestModelNewArticlePopup';
import {
    ViewedPopupRequestModelNewArticlePopupFromJSON,
    ViewedPopupRequestModelNewArticlePopupFromJSONTyped,
    ViewedPopupRequestModelNewArticlePopupToJSON,
} from './ViewedPopupRequestModelNewArticlePopup';
import type { ViewedPopupRequestModelRecommendationPopup } from './ViewedPopupRequestModelRecommendationPopup';
import {
    ViewedPopupRequestModelRecommendationPopupFromJSON,
    ViewedPopupRequestModelRecommendationPopupFromJSONTyped,
    ViewedPopupRequestModelRecommendationPopupToJSON,
} from './ViewedPopupRequestModelRecommendationPopup';
import type { ViewedPopupRequestModelWaitFreeChargeCompletePopup } from './ViewedPopupRequestModelWaitFreeChargeCompletePopup';
import {
    ViewedPopupRequestModelWaitFreeChargeCompletePopupFromJSON,
    ViewedPopupRequestModelWaitFreeChargeCompletePopupFromJSONTyped,
    ViewedPopupRequestModelWaitFreeChargeCompletePopupToJSON,
} from './ViewedPopupRequestModelWaitFreeChargeCompletePopup';

/**
 * 閲覧したポップアップのリクエスト
 * @export
 * @interface ViewedPopupRequestModel
 */
export interface ViewedPopupRequestModel {
    /**
     * 
     * @type {ViewedPopupRequestModelCampaignPopup}
     * @memberof ViewedPopupRequestModel
     */
    campaignPopup?: ViewedPopupRequestModelCampaignPopup;
    /**
     * 
     * @type {ViewedPopupRequestModelWaitFreeChargeCompletePopup}
     * @memberof ViewedPopupRequestModel
     */
    waitFreeChargeCompletePopup?: ViewedPopupRequestModelWaitFreeChargeCompletePopup;
    /**
     * 
     * @type {ViewedPopupRequestModelNewArticlePopup}
     * @memberof ViewedPopupRequestModel
     */
    newArticlePopup?: ViewedPopupRequestModelNewArticlePopup;
    /**
     * 
     * @type {ViewedPopupRequestModelRecommendationPopup}
     * @memberof ViewedPopupRequestModel
     */
    recommendationPopup?: ViewedPopupRequestModelRecommendationPopup;
    /**
     * 
     * @type {ViewedPopupRequestModelAgreementTermPopup}
     * @memberof ViewedPopupRequestModel
     */
    agreementTermPopup?: ViewedPopupRequestModelAgreementTermPopup;
    /**
     * 
     * @type {ViewedPopupRequestModelMissionPopup}
     * @memberof ViewedPopupRequestModel
     */
    missionPopup?: ViewedPopupRequestModelMissionPopup;
}

/**
 * Check if a given object implements the ViewedPopupRequestModel interface.
 */
export function instanceOfViewedPopupRequestModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ViewedPopupRequestModelFromJSON(json: any): ViewedPopupRequestModel {
    return ViewedPopupRequestModelFromJSONTyped(json, false);
}

export function ViewedPopupRequestModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ViewedPopupRequestModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'campaignPopup': !exists(json, 'campaignPopup') ? undefined : ViewedPopupRequestModelCampaignPopupFromJSON(json['campaignPopup']),
        'waitFreeChargeCompletePopup': !exists(json, 'waitFreeChargeCompletePopup') ? undefined : ViewedPopupRequestModelWaitFreeChargeCompletePopupFromJSON(json['waitFreeChargeCompletePopup']),
        'newArticlePopup': !exists(json, 'newArticlePopup') ? undefined : ViewedPopupRequestModelNewArticlePopupFromJSON(json['newArticlePopup']),
        'recommendationPopup': !exists(json, 'recommendationPopup') ? undefined : ViewedPopupRequestModelRecommendationPopupFromJSON(json['recommendationPopup']),
        'agreementTermPopup': !exists(json, 'agreementTermPopup') ? undefined : ViewedPopupRequestModelAgreementTermPopupFromJSON(json['agreementTermPopup']),
        'missionPopup': !exists(json, 'missionPopup') ? undefined : ViewedPopupRequestModelMissionPopupFromJSON(json['missionPopup']),
    };
}

export function ViewedPopupRequestModelToJSON(value?: ViewedPopupRequestModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'campaignPopup': ViewedPopupRequestModelCampaignPopupToJSON(value.campaignPopup),
        'waitFreeChargeCompletePopup': ViewedPopupRequestModelWaitFreeChargeCompletePopupToJSON(value.waitFreeChargeCompletePopup),
        'newArticlePopup': ViewedPopupRequestModelNewArticlePopupToJSON(value.newArticlePopup),
        'recommendationPopup': ViewedPopupRequestModelRecommendationPopupToJSON(value.recommendationPopup),
        'agreementTermPopup': ViewedPopupRequestModelAgreementTermPopupToJSON(value.agreementTermPopup),
        'missionPopup': ViewedPopupRequestModelMissionPopupToJSON(value.missionPopup),
    };
}

